import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vShow as _vShow, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29cc8cf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-info-circle me-2" }, null, -1))
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "milestone",
  class: "form-label text-muted"
}, " ประวัติความเป็นมา: ", -1))
const _hoisted_5 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "organization",
  class: "form-label text-muted"
}, " โครงสร้างและแผนผังองค์กร: ", -1))
const _hoisted_8 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "authority",
  class: "form-label text-muted"
}, " อำนาจหน้าที่: ", -1))
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "visionMission",
  class: "form-label text-muted"
}, " วิสัยทัศน์/พันธกิจ: ", -1))
const _hoisted_14 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban" }, null, -1))
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-save" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseModalComponent = _resolveComponent("BaseModalComponent")!

  return (_openBlock(), _createBlock(_component_BaseModalComponent, {
    ref: "informationForm",
    backdrop: "static",
    onHide: _ctx.clearForm
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode("แก้ไข" + _toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_ctx.submited && _ctx.errors.milestone)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " * กรุณาป้อนประวัติความเป็นมา "))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("textarea", {
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.milestone}]),
            placeholder: "กรุณาป้อนข้อมูลประวัติความเป็นมา...",
            "aria-label": "milestone",
            rows: "10",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.milestone) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
          }, "\n          ", 34), [
            [
              _vModelText,
              _ctx.formData.milestone,
              void 0,
              { trim: true }
            ]
          ])
        ], 512), [
          [_vShow, _ctx.mode === 'MILESTONE']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          (_ctx.submited && _ctx.errors.organization)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " * กรุณาป้อนโครงสร้างและแผนผังองค์กร "))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("textarea", {
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.organization}]),
            placeholder: "กรุณาป้อนข้อมูลโครงสร้างและแผนผังองค์กร...",
            "aria-label": "organization",
            rows: "10",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.organization) = $event)),
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
          }, "\n          ", 34), [
            [
              _vModelText,
              _ctx.formData.organization,
              void 0,
              { trim: true }
            ]
          ])
        ], 512), [
          [_vShow, _ctx.mode === 'ORGANIZATION']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          (_ctx.submited && _ctx.errors.authority)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, " * กรุณาป้อนอำนาจหน้าที่ "))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("textarea", {
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.authority}]),
            placeholder: "กรุณาป้อนข้อมูลอำนาจหน้าที่...",
            "aria-label": "authority",
            rows: "10",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.authority) = $event)),
            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
          }, "\n          ", 34), [
            [
              _vModelText,
              _ctx.formData.authority,
              void 0,
              { trim: true }
            ]
          ])
        ], 512), [
          [_vShow, _ctx.mode === 'AUTHORITY']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          (_ctx.submited && _ctx.errors.visionMission)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " * กรุณาป้อนวิสัยทัศน์/พันธกิจ "))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("textarea", {
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.visionMission}]),
            placeholder: "กรุณาป้อนข้อมูลวิสัยทัศน์/พันธกิจ...",
            "aria-label": "vision-mission",
            rows: "10",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.visionMission) = $event)),
            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
          }, "\n          ", 34), [
            [
              _vModelText,
              _ctx.formData.visionMission,
              void 0,
              { trim: true }
            ]
          ])
        ], 512), [
          [_vShow, _ctx.mode === 'VISIONMISSION']
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: _ctx.isLoading,
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        _hoisted_16,
        _createTextVNode(" ปิด ")
      ], 8, _hoisted_15),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: _ctx.isLoading,
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, [
        _hoisted_18,
        _createTextVNode(" บันทึก ")
      ], 8, _hoisted_17)
    ]),
    _: 1
  }, 8, ["onHide"]))
}